import React from 'react';

const CircleArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82 82">
        <g fill="none" fillRule="evenodd">
            <circle
                cx="41"
                cy="41"
                r="41"
                fill="currentColor"
                fillRule="nonzero"
            />
            <path
                fill="#1A488D"
                fillRule="nonzero"
                d="m53.369 39.468-10.77-10.833a2.144 2.144 0 0 0-3.045 0 2.175 2.175 0 0 0 0 3.064l7.093 7.134H28.154A2.16 2.16 0 0 0 26 41a2.16 2.16 0 0 0 2.154 2.167h18.493L39.554 50.3a2.175 2.175 0 0 0 0 3.064 2.14 2.14 0 0 0 3.046 0l10.769-10.833a2.175 2.175 0 0 0 0-3.064Z"
            />
        </g>
    </svg>
);

export default CircleArrow;
